/*
 * @Author: Teemo Ding
 * @Date: 2021-08-11 17:54:43
 * @LastEditors: Json Chen
 * @LastEditTime: 2023-04-25 08:46:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/LegalConsent/index.tsx
 */
import { SizeFittingTable, Tag } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { formatTimeBySetting, getParameter } from '@/src/tools/helper';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import React from 'react';
import { useSelector } from 'react-redux';
import { getBasicSetting } from 'src/constrains/GlobalProvider/slice';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { consentColumns } from '../config';
import css from '../css.module.less';

const permissions = () => {
  const access_page_and_view_customer_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.access_page_and_view_customer_details_page,
      }),
    ],
  });
  return {
    access_page_and_view_customer_details_page,
  };
};
const LegalConsent = ({
  consentAttributes,
  termsConditions,
  timezoneInGMT,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const format = formatTimeBySetting(useSelector(getBasicSetting()));

  const { access_page_and_view_customer_details_page } = permissions();
  const parameterType = getParameter('type');
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.informationContainer} ${css.legalConsentContainer} ${css.wrapperContainer}`}
        title={getI18n('customerList.legalConsent.legalConsent')}>
        <div className={css.consentAttribute}>
          <h3>{getI18n('customerList.legalConsent.consentAttribute')}</h3>
          {(consentAttributes || []).map((attr, index) => (
            <Tag key={index}>{attr}</Tag>
          ))}
        </div>
        <h3>{getI18n('customerList.legalConsent.terms&ConditionConsent')}</h3>
        <SizeFittingTable
          columns={consentColumns(
            parameterType,
            timezoneInGMT,
            { getI18n },
            !access_page_and_view_customer_details_page,
            format,
          )}
          pagination={false}
          id='legalConsentTable'
          // rowKey='uuid'
          scroll={{ y: 560 }}
          dataSource={termsConditions}
        />
      </SectionWrapper>
    </div>
  );
};

export default LegalConsent;
